import { render, staticRenderFns } from "./vant-up-down.vue?vue&type=template&id=5b00a726&scoped=true"
import script from "./vant-up-down.vue?vue&type=script&lang=js"
export * from "./vant-up-down.vue?vue&type=script&lang=js"
import style0 from "./vant-up-down.vue?vue&type=style&index=0&id=5b00a726&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b00a726",
  null
  
)

export default component.exports